module.exports = __webpack_public_path__ + "static/turquia-005-9af722cef1e11b9972ba6c549372e88f.jpg";